export class CaptchaCtrl {

    constructor({captchaApiBaseUrl}) {
        this.captchaApiBaseUrl = captchaApiBaseUrl;
    }

    /**
     * Récupère un captcha
     * @return retourne une {Promise} pour récupération du captcha
     */
    getCaptcha() {
        return new Promise((resolve, reject) => {
            $.ajax({
                method: "GET",
                xhrFields: {
                    withCredentials: true
                },
                url: this.captchaApiBaseUrl,
                dataType: "json",
                contentType: "application/json",
            }).done((data) => {
                resolve(data)
            }).fail((error) => {
                reject(error)
            });
        });
    }
}
